export default __webpack_public_path__ + "static/media/ats-sync-promo.b8fb6426.png";